import { Component, signal, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { AvatarModule } from 'ngx-avatars';
import { NostosService } from './services/nostos.service';
import { Me } from './models/me';
import Keycloak from 'keycloak-js';
import { Version } from './models/version';

@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    RouterOutlet,
    MatSidenavModule,
    MatListModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    AvatarModule,
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    MatMenuModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {

  protected readonly title = signal('WebUi');
  me: Me | undefined = undefined;
  downloadsUrl: string | undefined;
  version: Version = { version: "" }

  private readonly keycloak = inject(Keycloak);

  constructor(private nostosService: NostosService, ) {

  }

  ngOnInit() {

    this.downloadsUrl = this.nostosService.getDownloadsUrl();

    this.nostosService.getMe().subscribe(result => {
      this.me = result;
      this.nostosService.getVersion().subscribe(v => {
        this.version = v;
      });
    });

  }

  logout() {
    try {
      this.keycloak.logout();
    } catch (err) {
      console.error('Logout failed', err);
    }

  }

}
